module.exports = __webpack_public_path__ + "static/media/logoutv2.20f8bbbc.svg";